import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "./Book2.css";

const BookNowsec2 = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [enq, setEnq] = useState("");
  const [msg, setMsg] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = { name, phone, enq, msg };
    console.log(info);
  };
  return (
    // <div className="h-screen w-screen booknow2-main">
    //   <div className="booknow2-img"></div>
    //   <div className="booknow2-img2"></div>
    // </div>
    <>
      <div className="container-fluid main-div ">
        <div className="container">
          <div className="row p-0">
            <div className="col-lg-6 col-md-12 p-0">
              <Swiper
                modules={[Autoplay]}
                spaceBetween={0}
                slidesPerView={1}
                autoplay
              >
                <SwiperSlide>
                  <div className="contact_img1">
                    <img
                      className="imageb1"
                      src="./IMG-20240625-WA00542.png"
                      alt="#"
                    />
                    <div className="contact_img1-bg"></div>
                    <div className="contact_img1-bg_text">
                      <h1 className="contact_img1-bg_text_h1">OUR EVENTS</h1>
                      <p>We can’t wait to share our special day with you :)</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="contact_img1">
                    <img
                      className="imageb1"
                      src="./IMG-20240625-WA00542.png"
                      alt="#"
                    />
                    <div className="contact_img1-bg"></div>
                    <div className="contact_img1-bg_text">
                      <h1 className="contact_img1-bg_text_h1">OUR EVENTS</h1>
                      <p>We can’t wait to share our special day with you :)</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="contact_img1">
                    <img
                      className="imageb1"
                      src="./IMG-20240625-WA00542.png"
                      alt="#"
                    />
                    <div className="contact_img1-bg"></div>
                    <div className="contact_img1-bg_text">
                      <h1 className="contact_img1-bg_text_h1">OUR EVENTS</h1>
                      <p>We can’t wait to share our special day with you :)</p>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
            <div className="col-lg-6 col-md-12 book-m2 p-0">
              <div className="">
                <img className="booknowbg" src="booknowbg.png" alt="bg" />
              </div>
              <h1 className="heading">Contact Us</h1>
              <div className="container-fluid p-0">
                <div className="row p-0">
                  {/* <div className="col-1 "></div> */}
                  <div className="col-12">
                    <form onSubmit={handleSubmit}>
                      <div className="col-8 book-m8 ">
                        <div className=" inp-contianer">
                          <input
                            className="inp"
                            type="text"
                            placeholder="Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                          <input
                            className="inp "
                            type="number"
                            placeholder="Phone"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                          />
                        </div>
                        <br />
                        <input
                          className="Enq"
                          type="text"
                          placeholder="Enquiry"
                          value={enq}
                          onChange={(e) => setEnq(e.target.value)}
                        />
                        <br />
                        <br />
                        <input
                          className="Msg"
                          type="text"
                          placeholder="Message"
                          value={msg}
                          onChange={(e) => setMsg(e.target.value)}
                        />
                        <div className="d-flex justify-content-center align-items-center">
                          <button className="btn-submit">Send Message</button>
                        </div>
                      </div>
                    </form>
                  </div>
                  {/* <div className="col-1"></div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookNowsec2;
